import { render } from "./CookieLayer.vue?vue&type=template&id=2beafb6e"
import script from "./CookieLayer.vue?vue&type=script&lang=js"
export * from "./CookieLayer.vue?vue&type=script&lang=js"

import "./CookieLayer.vue?vue&type=style&index=0&id=2beafb6e&lang=scss"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__